module.exports = __webpack_public_path__ + "static/img/3177_phase_function_Paper_Points.8b6d2f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3177_phase_function_Paper_Points.png
// module id = aD/v
// module chunks = 0